module.exports = __webpack_public_path__ + "static/media/Default.782adc2b.png";